import { getDefaultProvider } from 'm_ccbc';

export const getRpcProvider = (
  providerLink = 'https://xcbapi.corecoin.cc/'
) => {
  const provider = getDefaultProvider(providerLink);
  return provider;
};
